import React from 'react'
class LoyaltyPointHistory extends React.Component {
  render() {
    return (
      <div className="page-body">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-block">
                <div className="dt-responsive table-responsive">Coming Soon...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LoyaltyPointHistory
